import React from 'react'
import { Helmet } from 'react-helmet'
import { toast } from 'react-toastify'
import { FormattedMessage } from 'react-intl'
import { Alert, Button, Spinner } from 'lib/ui'
import { Failure } from 'lib/ui/components/Toast/components/Failure'
import { useCommerceHubGooglePay } from 'lib/modules/commercehub'
import { Container, SaveCard } from './styled'

const GOOGLE_PAY_SDK_URL = 'https://pay.google.com/gp/p/js/pay.js'

/**
 * Google Pay payment-method component (architecture §2.2). The `pay.js` SDK is
 * lazy-loaded here (Helmet <script>, Affirm-module pattern) - only while this
 * component is mounted, not part of the global bundle.
 *
 * Design decision (architecture §7 Q6): same reasoning as Apple Pay - this
 * component renders its own button as the direct place-order trigger (instead
 * of the generic `usePaymentMethod` "Place Order" flow) to keep the wallet-sheet
 * gesture user-initiated.
 */
export const CommerceHubGooglePay = () => {
  const {
    available,
    eligibilityLoading,
    canSaveCard,
    saveCard,
    setSaveCard,
    placeGooglePayOrder
  } = useCommerceHubGooglePay()

  const handleError = () => {
    toast(() => (
      <Failure
        messageId='app.whoops'
      />
    ), {
      autoClose: 15000
    })
  }

  return (
    <Container>
      <Helmet>
        <script src={GOOGLE_PAY_SDK_URL} async />
      </Helmet>

      {eligibilityLoading && (
        <Spinner />
      )}

      {!eligibilityLoading && !available && (
        <Alert type='info'>
          <FormattedMessage
            id='checkout.googlePay.unavailable'
          />
        </Alert>
      )}

      {!eligibilityLoading && available && (
        <>
          {canSaveCard && (
            <SaveCard>
              <input
                id='commerce-hub-google-pay-save-card'
                type='checkbox'
                checked={saveCard}
                onChange={(e) => setSaveCard(e.target.checked)}
              />
              <label htmlFor='commerce-hub-google-pay-save-card'>
                <FormattedMessage
                  id='checkout.wallet.label.save'
                />
              </label>
            </SaveCard>
          )}

          <Button
            type='button'
            skin='regular'
            onClick={() => {
              placeGooglePayOrder({ onError: handleError })
            }}
          >
            <FormattedMessage
              id='checkout.googlePay.action.pay'
            />
          </Button>
        </>
      )}
    </Container>
  )
}
